import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'
import Thing from '../utilities/Data/Thing'
import maybe from '../utilities/maybe'
import flatten from '../utilities/flatten'

const removeDuplicates = arr => [...(new Set(arr))]

const getItemOwnWants = async ({ stateItemOwnByKey = {}, item, itemsOwned, itemsWanted, result, feed, posts, kit, post }) => {
	try {
		// get to the entities in whatever was passed in
		const searchedItems = (result && result.hits) || [] // TODO: sagafy search and won't need this
		const allPosts = [...(feed || []), ...(posts || []), ...maybe([post], post)]
		const taggedItems = allPosts
			.reduce((tags, p) => [...tags, ...p.tags], [])
			.filter(Thing.isItem)
		const kitItemKeys = flatten(allPosts.map(iPost => ((iPost.kit && iPost.kit.items) || []))).filter(Thing.isItem)
		const kitItems = (kit && kit.items) || []

		// from all of the items passed in, get the unique itemKeys
		const allItems = [
			...maybe([item], item), // itemFetch_Success
			...maybe(itemsOwned, itemsOwned), // userProfileItemsOwnedFetch_Success
			...maybe(itemsWanted, itemsWanted), // userProfileItemsWantedFetch_Success
			...maybe(searchedItems, searchedItems.length), // searchItem_Success
			...maybe(taggedItems, taggedItems.length), // feedFetch_Success, userProfilePostsFetch_Success, postFetch_Success
			...maybe(kitItems, kitItems.length), // kitFetch_Success
			...maybe(kitItemKeys, kitItemKeys.length)
		]
		const itemKeys = removeDuplicates(allItems.map(k => k.itemKey))
			.filter(itemKey => stateItemOwnByKey[itemKey] === undefined) // filter out any we already have data for

		// request the data
		const uid = getCurrentUid()
		const ownerDocSnaps = await Promise.all(itemKeys.map(async itemKey => firestore.collection('items').doc(itemKey).collection('owners').doc(uid).get()))
		const wanterDocSnaps = await Promise.all(itemKeys.map(async itemKey => firestore.collection('items').doc(itemKey).collection('wanters').doc(uid).get()))

		// provide data by itemKey
		const itemOwnByKey = itemKeys.reduce((owns, itemKey, i) => ({
			...owns,
			[itemKey]: ownerDocSnaps[i].exists && ownerDocSnaps[i].data()
		}), {})
		const itemWantByKey = itemKeys.reduce((wants, itemKey, i) => ({
			...wants,
			[itemKey]: wanterDocSnaps[i].exists && wanterDocSnaps[i].data()
		}), {})

		return { itemOwnByKey, itemWantByKey }
	} catch (error) {
		console.log(error)
		throw errorOfType(errorTypes.UNKNOWNERROR, error)
	}
}

export default getItemOwnWants



// WEBPACK FOOTER //
// ./src/dataservices/getItemOwnWants.js